// Map well-known authority citations to their canonical reference URLs.
// When the planner emits one of these strings on a glossary item / proper noun,
// the AnnotationTooltip renders it as a clickable link rather than plain text -
// reframing "AI decided" as "AI applied standard XYZ".

const CITATION_URLS = {
  'KMU 2010': 'https://zakon.rada.gov.ua/laws/show/55-2010-%D0%BF',
  'BGN/PCGN 1947': 'https://www.gov.uk/government/publications/romanisation-systems',
  'ICAO 9303': 'https://www.icao.int/publications/pages/publication.aspx?docnum=9303',
  'ISO 9': 'https://www.iso.org/standard/3589.html',
  'Bologna Process': 'https://education.ec.europa.eu/education-levels/higher-education/inclusive-and-connected-higher-education/bologna-process',
  'Eurojust': 'https://www.eurojust.europa.eu/',
};

export function getCitationUrl(citation) {
  if (!citation) return null;
  return CITATION_URLS[citation] ?? null;
}
